import { UPLOAD_CARE_CSS_SRC } from './UploadCareWidget.constants';
export function getFileSelectionMessage(count) {
  if (count === 0) {
    return '';
  }
  var fileLabel = count === 1 ? 'file' : 'files';
  return "".concat(count, " ").concat(fileLabel, " uploaded");
}
export function getUploadCareConfigSettings(_ref) {
  var ctxName = _ref.ctxName,
    publicKey = _ref.publicKey,
    maxLocalFileSizeBytes = _ref.maxLocalFileSizeBytes,
    sourceList = _ref.sourceList,
    multiple = _ref.multiple;
  return {
    'ctx-name': ctxName,
    pubkey: publicKey,
    maxLocalFileSizeBytes: maxLocalFileSizeBytes,
    sourceList: sourceList,
    multiple: multiple,
    removeCopyright: true
  };
}
export function getFileUploaderConfigSettings(_ref2) {
  var ctxName = _ref2.ctxName;
  return {
    'ctx-name': ctxName,
    'css-src': UPLOAD_CARE_CSS_SRC,
    "class": 'upload-care-file-uploader'
  };
}